export default __webpack_public_path__ + "static/media/regulatory--bike-route--g1.10d044ee.png";